import { format, startOfDay } from 'date-fns';

export interface RolliDueStatus {
  lastDoneDate?: string | null;
  naechsteFaelligkeitDate?: string | null;
}

/**
 * Verwendet dieselbe Fälligkeitsregel wie die Dashboard-Rolli-Aufgaben:
 * Ein Rolli ist offen, wenn er heute oder früher fällig ist und nicht
 * bereits heute erledigt wurde.
 */
export function isRolliDueTodayOrOverdue(
  rolli: RolliDueStatus,
  now: Date = new Date(),
): boolean {
  const today = startOfDay(now);
  const todayString = format(today, 'yyyy-MM-dd');

  if (rolli.lastDoneDate?.slice(0, 10) === todayString) {
    return false;
  }

  if (!rolli.naechsteFaelligkeitDate) {
    return false;
  }

  const dueDate = startOfDay(new Date(rolli.naechsteFaelligkeitDate));
  if (Number.isNaN(dueDate.getTime())) {
    return false;
  }

  return dueDate.getTime() <= today.getTime();
}

export function countDueRollis(
  rollis: readonly RolliDueStatus[],
  now: Date = new Date(),
): number {
  return rollis.filter((rolli) => isRolliDueTodayOrOverdue(rolli, now)).length;
}
